import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { I2FAResponse, ILogin, ILoginResponse } from '@/lib/api/auth/types';
import { IUserSlice } from '@/redux/slices/user/types';

export const tryLogin = createAsyncThunk(
  'user/tryLogin',
  async (data: ILogin, { rejectWithValue }) =>
    await axios
      .post('/api/login', data)
      .catch((err) => rejectWithValue(err.response.data))
      .then((res: any) => {
        if (res.data) return res.data;
        return res;
      })
);

const pending = (state: IUserSlice) => {
  state.user.loading = true;
};

const fulfilled = (
  state: IUserSlice,
  { payload }: { payload: ILoginResponse | I2FAResponse }
) => {
  state.user.loading = false;
};

const rejected = (state: IUserSlice) => {
  state.user.loading = false;
};
export default {
  action: tryLogin,
  pending,
  fulfilled,
  rejected,
};
